import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

/** Requests where a 401 is the answer itself, not an expired session. */
const AUTH_ENDPOINTS = ['/auth/login', '/auth/register', '/auth/forgot-password', '/auth/reset-password'];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  const headers: { [key: string]: string } = {
    Accept: 'application/json',
  };

  // Get token directly from localStorage to avoid circular dependency
  const token = typeof window !== 'undefined' ? window.localStorage?.getItem('token') : null;
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  // Add organization ID header if available (directly from localStorage)
  const organizationId = typeof window !== 'undefined' ? window.localStorage?.getItem('currentOrganizationId') : null;
  if (organizationId) {
    headers['X-Organization-Id'] = organizationId;
  }

  req = req.clone({
    setHeaders: headers,
  });

  return next(req).pipe(
    catchError((error: unknown) => {
      // Tokens expire, so a 401 on an authenticated request means the session is
      // over. Without this the app keeps its stale token and every screen fails.
      const isExpiredSession =
        error instanceof HttpErrorResponse &&
        error.status === 401 &&
        !!token &&
        !AUTH_ENDPOINTS.some((endpoint) => req.url.includes(endpoint));

      if (isExpiredSession) {
        window.localStorage?.removeItem('token');
        window.localStorage?.removeItem('currentOrganizationId');
        router.navigateByUrl('/auth/login');
      }

      return throwError(() => error);
    }),
  );
};
